import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

interface Props {
  containerTag?: string;
  position?: 'top' | 'right' | 'bottom' | 'left' | 'top-left';
  color?: 'primary' | 'secondary' | 'danger' | 'accent' | 'accent-second' | 'success-fill';
  disabled?: boolean;
  message?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    containerTag: { default: 'div' },
    position: { default: 'bottom' },
    color: { default: 'primary' },
    disabled: { type: Boolean, default: false },
    message: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.containerTag), {
    class: _normalizeClass([_ctx.$style.wrapper, { disabled: _ctx.disabled }]),
    "data-type": "tooltip"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.$slots.message || _ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([
        _ctx.$attrs.class,
        _ctx.$style.tooltip,
        _ctx.$style[`tooltip_${_ctx.position}`],
        _ctx.$style[`tooltip_${_ctx.color}`],
      ])
          }, [
            _renderSlot(_ctx.$slots, "message", {}, () => [
              _createElementVNode("div", { innerHTML: _ctx.message }, null, 8, _hoisted_1)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})